export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9826.aca5bb54.jpg";